import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/motion/Reveal";
import FaqAccordion from "@/components/FaqAccordion";

export default function FaqPreview({ faqs = [] }) {
  return (
    <section className="bg-white" aria-label="Frequently asked questions">
      <div className="container-rnv py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="overline">Questions</span>
              <h2 className="font-serif text-4xl md:text-5xl text-[#1E2A44] mt-3 leading-tight">
                Frequently Asked Questions
              </h2>
              <p className="mt-5 text-[#85827D] leading-relaxed">
                Answers to common questions about ordering, documentation, and our
                research-only positioning.
              </p>
              <Link to="/faq" className="btn-gold mt-8" data-testid="faq-view-all">
                View all FAQs
              </Link>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <FaqAccordion faqs={faqs} testIdPrefix="home-faq" />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
